import React from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

import WifiCredentials from 'components/ran/wifi-credentials'
import { dateToLocaleString } from 'helpers/date'

import styles from './ran-room-card-style'
import Alert from './alert'


const RanRoomCard = ({ theme, data, isNetworkDisplayed, i18n, t }) => {
  const classes = styles(theme)

  const end_date = dateToLocaleString({ date: data.end_date, language: i18n.language })

  return (
    <div className={classes.ranRoom}>
      <p className={classes.ranRoomTitle}>
        <span className={classNames('fal', 'fa-house-signal', classes.ranRoomIcon)} />
        <span dangerouslySetInnerHTML={{ __html: t('ran_room.room_name', { location: data.location_name }) }} />
      </p>
      <WifiCredentials psk={data.psk} ssid={isNetworkDisplayed ? data.ssid : null} />
      {end_date && <p className={classes.ranRoomFooter} dangerouslySetInnerHTML={{ __html: t('ran_activate.expire_in', { end_date })}} />}
      {!data.free && <Alert endDate={data.end_date} />}
    </div>
  )
}

RanRoomCard.propTypes = {
  data: PropTypes.object.isRequired,
  isNetworkDisplayed: PropTypes.bool,
  theme: PropTypes.object.isRequired,
}

RanRoomCard.defaultProps = {
  isNetworkDisplayed: true,
}

export default compose(
  withTheme,
  withTranslation(),
)(RanRoomCard)
